import { useEffect, useMemo, useState } from "react";
import { Captions, CaptionsOff } from "lucide-react";

const ts = (s) => { const d = new Date(Math.max(0, s) * 1000); return d.toISOString().substring(11, 23); };

export const useCaptionTrack = (segments) => useMemo(() => {
  if (!segments?.length) return null;
  const body = segments.map((s, i) => `${i + 1}\n${ts(s.start)} --> ${ts(Math.max(s.end, s.start + 0.5))}\n${s.text}`).join("\n\n");
  return URL.createObjectURL(new Blob([`WEBVTT\n\n${body}\n`], { type: "text/vtt" }));
}, [segments]);

export const useCurrentSegment = (mediaRef, segments) => {
  const [t, setT] = useState(0);
  useEffect(() => {
    const el = mediaRef.current;
    if (!el) return;
    const h = () => setT(el.currentTime);
    el.addEventListener("timeupdate", h); el.addEventListener("seeked", h);
    return () => { el.removeEventListener("timeupdate", h); el.removeEventListener("seeked", h); };
  }, [mediaRef, segments]);
  const i = segments?.findIndex((s) => t >= s.start && t < Math.max(s.end, s.start + 0.5));
  return i >= 0 ? i : -1;
};

export const CaptionBar = ({ segments, current, on, onToggle, onSeek, showLine = true }) => {
  if (!segments?.length) return null;
  return (
    <div className="mt-2" data-testid="media-captions">
      <div className="flex items-center justify-between gap-2">
        <button type="button" onClick={onToggle} className="inline-flex items-center gap-1.5 text-xs text-primary hover:underline" data-testid="media-captions-toggle" aria-pressed={on}>
          {on ? <Captions className="h-3.5 w-3.5" /> : <CaptionsOff className="h-3.5 w-3.5" />} {on ? "Captions on" : "Captions off"}
        </button>
        <span className="text-[11px] text-muted-foreground">Tap a line to jump there</span>
      </div>
      {on && showLine && (
        <p className="mt-1.5 min-h-[2.75rem] rounded-xl bg-foreground/90 text-background text-center text-sm sm:text-base leading-snug px-4 py-2 font-serif" aria-live="polite" data-testid="media-caption-line">
          {current >= 0 ? segments[current].text : "\u00a0"}
        </p>
      )}
      <ol className="mt-2 max-h-40 overflow-y-auto rounded-xl border border-border bg-muted/30 divide-y divide-border/60" data-testid="media-caption-list">
        {segments.map((s, i) => (
          <li key={i}>
            <button type="button" onClick={() => onSeek(s.start)} className={`w-full text-left px-3 py-1.5 text-sm flex gap-3 hover:bg-primary/5 ${i === current ? "bg-primary/10 font-medium" : ""}`} data-testid={`media-caption-seg-${i}`}>
              <span className="font-mono text-[11px] text-muted-foreground shrink-0 pt-0.5">{ts(s.start).substring(3, 8)}</span>
              <span className="flex-1">{s.text}</span>
            </button>
          </li>
        ))}
      </ol>
    </div>
  );
};
